import { api } from "../client";

type RedirectResponse = { status: string; userid: string; message: string /* the Garmin authorize URL */ };

export const garminApi = {
  /**
   * OAuth2 PKCE (#285): the client's callback URL travels in the body — the
   * server stores it (with the code verifier) against the returned state and
   * echoes it at the token exchange, so nothing is appended client-side.
   */
  /** Anonymous: mints a temp guid and returns the Garmin authorize URL. */
  redirectUrlAnonymous: (callback: string) =>
    api<RedirectResponse>("garmin/redirecturl", { body: { callback } }),
  /** Logged-in user linking Garmin to an existing account. */
  redirectUrl: (callback: string) => api<RedirectResponse>("garmin/redirect", { body: { callback } }),
  /**
   * Finish an anonymous sign-in. `tempGuid` is the guid `redirecturl` minted,
   * IF this browser still has it. The server resolves the guid from the
   * `state` record either way (it stored the guid beside the code verifier
   * when it built the authorize URL), so a callback that lands in a browser
   * which never saw the sign-in start completes without it - which is the
   * normal case on a phone with Garmin Connect installed: the app takes the
   * consent and opens the callback in the system default browser (#438).
   * With no temp guid, NO key is sent: another account signed in on that
   * browser must not be attached to the request.
   */
  createUser: (code: string, state: string, tempGuid: string | null) =>
    api<{ error: boolean; userid: string }>("garmin/createuser", {
      body: { code, state, userid: tempGuid ?? undefined },
      authKeyOverride: tempGuid ?? "",
      ignoreAuthFailure: true,
    }),
  setToken: (code: string, state: string) =>
    api<{ error: boolean; message: string }>("garmin/settoken", { body: { code, state } }),
};
